export const isDev = process.env.NODE_ENV === 'development';
export const FRUSTUM_SIZE = 100;
export const CLOUD_TEXTURE_PATH = '/textures/cloud.jpg';
export const STAR_TEXTURE_PATH = '/textures/star.png';
export const COVER_TEXTURES_PATH = '/textures/covers/';
export const MAIN_COVER_TEXTURE_PATH = '/textures/covers/main.png';
